import React, { CSSProperties, FC, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'styles/colors';
import { useInView } from 'react-intersection-observer';
import ReactPlayer from 'react-player';

const VideoWrapper = styled.div<{ height?: string; width?: string }>`
  border-radius: 10px;
  max-width: 100%;
  overflow: hidden;
  ${({ height, width }) => css`
    height: ${height};
    width: ${width};
  `}
`;

type Props = {
  id: string;
  ratio: number;
  width?: number;
  style?: CSSProperties;
};

// TODO: find a better solution for the default width
export const VideoPlayer: FC<Props> = ({ id, ratio, width, style }) => {
  const [showControls, setShowControls] = useState(true);
  const { ref, inView } = useInView();
  const [showPlayer, setShowPlayer] = useState(false);
  const defaultWidth = 744;
  const height = (width ? width : defaultWidth) * ratio;
  useEffect(() => {
    inView && !showPlayer && setShowPlayer(true);
  }, [inView, showPlayer]);

  return (
    <VideoWrapper
      ref={ref}
      width={width ? width + 'px' : defaultWidth + 'px'}
      onMouseEnter={() => setShowControls(true)}
      onMouseLeave={() => setShowControls(false)}
      style={style}
    >
      {showPlayer && (
        <ReactPlayer
          url={`https://vimeo.com/${id}`}
          width={style?.width? style.width : `${width}px`}
          height={style?.height? style.height : `${height}px`}
          config={{
            vimeo: {
              playerOptions: {
                controls: showControls,
                color: colors.primary,
              },
            },
          }}
        />
      )}
    </VideoWrapper>
  );
};
